import { render } from "./FAQSections.vue?vue&type=template&id=636e974e"
import script from "./FAQSections.vue?vue&type=script&lang=js"
export * from "./FAQSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__